import React from 'react'
import { cn } from '../../../../utils'

export default function SmoothLoader({ className, variant ='light' }) {
  return (
    <div
      className={cn(
        'smooth-loader h-[18px] w-[18px] border-[2px] border-high',
        variant === 'light' ? 'border-high' : 'border-white',
        className
      )}
    ></div>
  );
}
